export default {
  placeholders: {
    delivery_zip_code: 'Postleitzahl',
    delivery_city: 'Stadt',
    delivery_street_number: 'Hausnummer',
    delivery_street_name: 'Straßenname',
    type_your_address: 'Geben Sie Ihre Adresse ein',
  },
};
